var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSeatLogoFooter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 200",
    style: {
      enableBackground: "new 0 0 200 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M143,156.3v8.7h-27.6v-2.4c0-3.8,0.6-6.3,5-6.3H143z M118.7,150.9c-7.3,0-10.6,3.9-10.6,10v17.4h7.3v-8H143v8 h7.3v-27.4H118.7z M159.1,150.9v5.4h17.1v22.1h7.3v-22.1h17.1v-5.4H159.1z M61.5,167.8c0,3.8,0.8,5.2,5,5.2h30.3v5.4h-32 c-7.3,0-10.6-3.3-10.6-9.4v-18h42.6v5.4H61.5v5.4h33.9v5.2H61.5V167.8z M9.6,160.4c-2.2-0.2-2.6-1-2.6-2.3c0-1.2,0.7-2,2.4-2h33.4 v-5.3H8.5c-4.9,0-8.2,1.9-8.2,7.3c0,5.5,2.5,7.3,8.1,7.8l27.1,2.3c2.1,0.2,2.7,0.9,2.7,2.4c0,1.4-0.6,2.3-2.5,2.3h-34v5.4h34.6 c6,0,8.6-2.4,8.6-8c0-5.1-2.4-7.2-8.2-7.7L9.6,160.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M42.1,57.2c0.1-3.7,0.3-12.9,0.5-18.3c0.2-6.9,1.7-11.1,4.5-13.7c3.9-3.5,8.5-4.3,19.5-4.9 c25.4-1.4,51.3-1.2,83.8,1.1c3.4,0.2,4.7,0.9,5.3,1.3c1.4,1,1.6,2.1,2,7.8c0.2,3.3,0.7,12.1,0.9,16.9 c-11.2-0.6-30.2-1.5-46.7-1.7c-16.5-0.2-31.4,0.1-33.2,0.3c-3.6,0.5-5.3,2.2-5.8,2.9l85.9,15.9v12.5L42.1,57.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M42,63.3L158.7,85c-0.1,3.2-0.3,13.2-0.5,19c-0.2,6.9-1.7,11.1-4.5,13.7c-3.9,3.5-8.5,4.3-19.5,4.9 c-25.4,1.4-51.3,1.2-83.8-1.1c-3.4-0.2-4.7-0.9-5.3-1.3c-1.4-1-1.6-2.1-2-7.8c-0.3-3.9-0.8-15.2-1-19c15.1,1,38.2,1.8,57,1.8 c4.7,0,17,0.1,20.3,0.1c2.6,0,6-0.7,7.7-3.4L42,77.4V63.3z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeatLogoFooter);
export default __webpack_public_path__ + "static/media/seat-logo-footer.2bdb6dfed4ebfacf0437875d54e9494b.svg";
export { ForwardRef as ReactComponent };